export default "__VITE_PUBLIC_ASSET__9c6a4838__"